import React, { useEffect, useState } from "react";
import { ReactComponent as SmileSvg } from "../../../src/svg/smilesvg.svg";
import { useHistory } from "react-router-dom";

const MobileCoachSelectFinish: React.FC<any> = (props) => {

    const history = useHistory();

    const submit = async () => {

        console.log("submit called");

        props.handleCurrentStatusChange(3);
        props.handleSubStatusChange(1);

    }



    return (
        <div>
            <div style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "8rem",
                alignItems: "center",
                flexDirection: "column",
            }}>
                <SmileSvg
                    style={{
                        marginBottom: "2.42rem"
                    }}
                />
                <div style={{
                    fontFamily: "Apple_SB",
                    fontSize: "1.3rem",
                    marginBottom: "0.81rem"
                }}>
                    코치 신청이 완료되었어요
                </div>
                <div style={{
                    textAlign: "center",
                    color: "#747474",
                    lineHeight: "1.5"
                }}>
                    본사 승인을 기다려주세요<br></br>
                    48시간 내에 앱채팅을 통해 전달할게요
                </div>
            </div>

            <div style={{
                width: "90.4%",
                backgroundColor: "#3d50b0",
                color: "white",
                position: "fixed",
                height: "3rem",
                bottom: "1.5rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "0.5rem",
                left: "50%",
                transform: "translateX(-50%)",
                fontFamily: "Apple_SB",
                cursor: "pointer",
            }}
                onClick={() => {
                    submit();
                }}
            >
                준비 자료 제출하러 가기
            </div>
        </div>
    )
}

export default MobileCoachSelectFinish;